import { X } from "lucide-react";
import { createPortal } from "react-dom";
import { useLightboxBehavior } from "@/hooks/useLightboxBehavior";
import { useVideoAutoplay } from "@/hooks/useVideoAutoplay";

export const VideoLightbox = ({ open, onClose, video, autoplay = true }) => {
  useLightboxBehavior(open, { onClose });
  const videoRef = useVideoAutoplay(open ? video?.mp4 : null, autoplay);

  if (!open || !video) return null;
  return createPortal(
    <div
      data-testid="video-lightbox"
      onClick={onClose}
      className="fixed inset-0 z-[1200] bg-[#0F0E0D]/95 backdrop-blur-sm flex items-center justify-center p-4 md:p-10 fade-up"
    >
      <button
        data-testid="video-lightbox-close"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        className="absolute top-4 right-4 md:top-6 md:right-6 z-20 w-11 h-11 border border-white/40 text-white/90 flex items-center justify-center hover:bg-white hover:text-[#1F1E1C] transition-colors"
        aria-label="Close video"
      >
        <X size={18} strokeWidth={1.5} />
      </button>
      <div
        onClick={(e) => e.stopPropagation()}
        className={`bg-black shadow-2xl ${
          video.portrait
            ? "h-[80vh] max-h-[80vh] aspect-[9/16] max-w-[92vw]"
            : "w-full max-w-5xl aspect-video"
        }`}
      >
        {video.youtubeId && (
          <iframe
            src={`https://www.youtube.com/embed/${video.youtubeId}?autoplay=${autoplay ? 1 : 0}&rel=0`}
            title={video.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-full h-full"
          />
        )}
        {!video.youtubeId && video.mp4 && (
          <video
            ref={videoRef}
            src={video.mp4}
            poster={video.poster || undefined}
            controls
            playsInline
            className="w-full h-full object-contain bg-black"
          />
        )}
      </div>
    </div>,
    document.body
  );
};
